import { TextField, Box } from "@mui/material";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "../inputsDatePicker/inputDatepicker.css";
import { es } from "date-fns/locale";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

interface InputPicker {
  startDate?: Date | null;
  endDate?: Date | null;
  setStartDate?: any;
  setEndDate?: any;
}

const CustomDateInput = forwardRef<HTMLInputElement, any>(({ value, onClick, placeholder }, ref) => (
  <TextField
    ref={ref}
    value={value}
    onClick={onClick}
    placeholder={placeholder}
    variant="outlined"
    size="small"
    fullWidth
    InputProps={{
      endAdornment: <CalendarTodayIcon color="action" />,
      readOnly: true,
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        cursor: 'pointer',
        '&:hover fieldset': {
          borderColor: '#1976d2',
        },
      },
    }}
  />
));

export const InputDatePicker = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}: InputPicker) => {
  const handleDateStartChange = (date: Date | null) => {
    setStartDate(date);
  };

  const handleDateEndChange = (date: Date | null) => {
    setEndDate(date);
  };

  return (
    <div className="date-picker-wrapper">
      <Box className="date-picker-item">
        <DatePicker
          locale={es}
          dateFormat="dd/MM/yyyy"
          selected={startDate}
          onChange={(date) => handleDateStartChange(date)}
          placeholderText="Fecha de inicio"
          customInput={<CustomDateInput />}
          showPopperArrow={false}
          popperClassName="custom-datepicker-popper"
        />
      </Box>
      <Box className="date-picker-item">
        <DatePicker
          locale={es}
          dateFormat="dd/MM/yyyy"
          placeholderText="Fecha de fin"
          selected={endDate}
          onChange={(date) => handleDateEndChange(date)}
          customInput={<CustomDateInput />}
          showPopperArrow={false}
          popperClassName="custom-datepicker-popper"
        />
      </Box>
    </div>
  );
};
